define('app/views/checkout_success_page_view',['app/setup', 'app/views/async_loading_coupons'], function(takhfifan) {
  takhfifan.CheckoutSuccessPageView = Backbone.View.extend({
    events: {
      'click .coupon-item .reserve-btn': 'reserve',
      'click .light-modal-body .close-btn' : 'hideDialog',
      'submit .tkh-modal-form' : 'formSubmission',
      'click .tkh-modal-form + .light-modal-footer a' : 'changeView'
    },

    reserewebTemplate: ($('#reserweb-widget-template').length > 0) ?
      _.template($('#reserweb-widget-template ').html()) : '',

    initialize: function () {
      this.isloggedIn = false;
      this.user = null;
      this.isUserVerified = false;
      this.customerPhoneNumber = null;
      var itemId;
      var serviceId;

      takhfifan.eventHub.on('customer:login', function(data) {
        this.isloggedIn = true;
        this.user = data;
      }, this);

      takhfifan.eventHub.on('formkey', function(formKey) {
        this.formKey = formKey;
      }, this);

      takhfifan.eventHub.on('customer:verification', function(data) {
        this.isUserVerified = data.verified;
      }, this);

      $('.tkh-checkout-success-info').each(function(){
        var $this = $(this);
        new takhfifan.AsyncLoadingCoupons({
          el: $this
        });
      });

      $(".pin-digit").on("keyup", function (e) {
        if (e.keyCode == 8 || e.keyCode == 48) {
          $(e.currentTarget).prev().select();
          $(e.currentTarget).prev().focus();
        } else {
          if ($(e.currentTarget).val() != "") {
            $(e.currentTarget).next().select();
            $(e.currentTarget).next().focus();
          }
        }
      });

    },

    changeView: function(e){
      this.showDialog($(e.currentTarget).data("type"));
    },

    formSubmission: function(e){
      e.preventDefault();
      var type = $(e.currentTarget).data("type");

      switch (type) {
        case "verifyPhoneNumber":
          this.submitPhoneNumber(e);
          break;
        case "verifyCode":
          this.submitVerificationCode(e);
          break;
        case "login":
          this.submitLogin(e);
          break;
        case "register":
          this.submitRegister(e);
          break;
        default:
            break;
      }
    },

    showReserveWebDialog:function (customer){
      var _this = this;
      $('.tkh-reserve-widget-container').html(_this.reserewebTemplate({
        customer: {
          name: customer.name,
          mobile: customer.mobile,
          email: customer.email,
        },
        service_id: this.serviceId,
        item_id: this.itemId,
      }));
    },

    reserve: function (e) {
      this.itemId = $(e.currentTarget).closest('.coupon-item').data('id');
      this.serviceId = $(e.currentTarget).closest('.coupon-item').data('service_id');
      if(this.isloggedIn){
        if(this.isUserVerified){
          $('.tkh-reserve-widget-container').html(this.reserewebTemplate({
            customer: {
              name: this.user.name,
              mobile: this.user.mobile
            },
            service_id: this.serviceId,
            item_id: this.itemId,
          }));
          this.showDialog("reserve");
        }else{
          this.showDialog("verification");
        }
      }else{
        this.showDialog("register");
      }
    },

    submitPhoneNumber: function (e) {
      e.preventDefault();
      var _this = this;
      this.loading();
      this.customerPhoneNumber = $(e.currentTarget).find('input[name="phone"]').val();
      var url = $(e.currentTarget).prop('action');
      var method = $(e.currentTarget).prop('method');
      $.ajax({
        url: url,
        type: method,
        data: {
          mobile: this.customerPhoneNumber,
          form_key: takhfifan.formKey
        }
      }).done(function (data) {
        _this.loading();
        if (data.success) {
          _this.showDialog("verify");
        } else {
          takhfifan.eventHub.trigger('message:show', {
            type: 'error',
            msg: data.message ? data.message : "در برقراری ارتباط خطایی پیش آمد"
          });
        }
      }).fail(function () {
        _this.loading();
        takhfifan.eventHub.trigger('message:show', {
          type: 'error',
          msg: "در برقراری ارتباط خطایی پیش آمد"
        });
      })
    },

    submitVerificationCode: function (e) {
      e.preventDefault();
      var _this = this,
          url = $(e.currentTarget).prop('action'),
          method = $(e.currentTarget).prop('method');

      this.loading();

      var code = $($(e.currentTarget).find('input[name="code"]')).map(function() {
        return $(this).val();
      }).get().join('');
      $.ajax({
        url: url,
        type: method,
        data: {
          mobile: this.customerPhoneNumber,
          code: code,
          form_key: takhfifan.formKey
        }
      }).done(function (data) {
        _this.loading();
        if (data.success) {
          if(_this.user){
            _this.showReserveWebDialog(_this.user);
          }
          _this.showDialog("reserve");
        } else {
          takhfifan.eventHub.trigger('message:show', {
            type: 'error',
            msg: data.message ? data.message : "کد وارد شده صحیح نیست"
          });
        }
      }).fail(function () {
        _this.loading();
        takhfifan.eventHub.trigger('message:show', {
          type: 'error',
          msg: "در برقراری ارتباط خطایی پیش آمد"
        });
      })
    },

    submitLogin: function (e) {
      e.preventDefault();
      var _this = this,
        url = $(e.currentTarget).prop('action'),
        method = $(e.currentTarget).prop('method'),
        $inputs = $('#login :input'),
        values = {};
      this.loading();

      $inputs.each(function() {
        values[this.name] = $(this).val();
      });
      var user = {
        form_key: this.formKey,
        login: {
          username: values['email'],
          password: values['password']
        }
      };
      $.ajax({
        url: url,
        type: method,
        data: user,
      }).done(function (data) {
        _this.loading();
        takhfifan.eventHub.trigger('customer:login', data.customer);
        if(data.verification.verified && data.customer.mobile){
          _this.showReserveWebDialog(data.customer);
          _this.showDialog("reserve");
        } else if(!data.verification.verified && data.errors.length===0) {
          $('.verify-phone').val(data.customer.mobile);
          _this.showDialog("verification");
        }
        else if(data.errors.length!==0){
          takhfifan.eventHub.trigger('message:show', {
            type: 'error',
            msg: data.errors
          });
        }
      }).fail(function () {
        _this.loading();
        takhfifan.eventHub.trigger('message:show', {
          type: 'error',
          msg: "در برقراری ارتباط خطایی پیش آمد"
        });
      })
    },

    submitRegister: function (e) {
      e.preventDefault();
      var _this = this,
        url = $(e.currentTarget).prop('action'),
        method = $(e.currentTarget).prop('method'),
        $inputs = $('#register :input'),
        values = {};

      this.loading();

      $inputs.each(function() {
        values[this.name] = $(this).val();
      });
      var user = {
        form_key: this.formKey,
        fullname: values['name'],
        mobile: values['phone'],
        email: values['email'],
        password: values['password'],
        create_address: 1,
        default_billing: 1,
        default_shipping: 0,
        street : ['-'],
        postcode: '-',
        country_id: 'IR',
        accepted_privacy_policy:true,
        is_subscribed : 1
      };

      $.ajax({
        url: url,
        type: method,
        data: user,
      }).done(function (data) {
        _this.loading();
        if (data.customer.name) {
          _this.user = {
            name: data.customer.name,
            email: data.customer.email,
            mobile: data.customer.mobile,
          };
          takhfifan.eventHub.trigger('customer:login', _this.user);
          _this.customerPhoneNumber = data.customer.mobile;
          if(data.customer.mobile){
            $.ajax({
              url: "/ajax/account/verifyPhoneNumber",
              type: "POST",
              data: {
                mobile: data.customer.mobile,
                form_key: takhfifan.formKey
              }
            }).done(function (response) {
              if (response.success) {
                _this.showDialog("verify");
              } else {
                takhfifan.eventHub.trigger('message:show', {
                  type: 'error',
                  msg: response.message ? response.message : "در برقراری ارتباط خطایی پیش آمد"
                });
              }
            }).fail(function () {
              _this.loading();
              takhfifan.eventHub.trigger('message:show', {
                type: 'error',
                msg: "در برقراری ارتباط خطایی پیش آمد"
              });
            })
          }
          else{
            _this.showDialog("verification");
          }
        } else {
          takhfifan.eventHub.trigger('message:show', {
            type: 'error',
            msg: "در برقراری ارتباط خطایی پیش آمد"
          });
        }
      }).fail(function () {
        _this.loading();
        takhfifan.eventHub.trigger('message:show', {
          type: 'error',
          msg: "در برقراری ارتباط خطایی پیش آمد"
        });
      })
    },

    showDialog: function (type) {
      this.hideDialog();
      $(".light-modal-body#"+type).addClass("active");
      if(!$('.light-modal-bg').hasClass('active')){
        $('.light-modal-bg').addClass('active')
      }
    },

    hideDialog: function () {
      $(".light-modal-bg, .light-modal-body").removeClass("active");
    },

    loading: function () {
      $('.light-modal-body .content').toggleClass("loading");
    }

  });
});

